import { Divider, Grid, Stack, Typography } from '@mui/material';
import { FeedDurationDefinitionInfo } from '../FeedDurationDefinitionInfo';
import { FeedFilterDefinitionInfo } from '../FeedFilterDefinitionInfo';

export const FeedDefinitionInfo = () => {
  return (
    <Stack spacing={1}>
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography variant="caption" color="inherit">
          Feed
        </Typography>
      </Stack>
      <Divider />
      <Grid
        container
        alignItems="flex-start"
        rowSpacing={1}
        columnSpacing={0.5}
      >
        <FeedFilterDefinitionInfo />
        <FeedDurationDefinitionInfo />
      </Grid>
    </Stack>
  );
};
